export const mapCandidateDetails = (response, masterData) => {
    // Handle Pre-Onboarding API response
    const data =
        response?.candidateParentModel ||
        response?.data?.candidateParentModel ||
        response ||
        {};


    const profile =
        data?.basicDetails?.candidateProfile || {};

    const personalDetails = response?.personalDetails || {}

    const addressDetails = response?.address || {}

    const domicileDetails = response?.domicileDetails || {}

    const address =
        data?.addressDetails || {};

    const documents =
        data?.documentDetails || [];

    const disability =
        data?.basicDetails?.disabilityDetails?.[0] || {};

    // Master Maps
    const genderMap = Object.fromEntries(
        (masterData?.genderMasters || []).map((item) => [
            item.genderId,
            item.gender,
        ])
    );

    const maritalStatusMap = Object.fromEntries(
        (masterData?.maritalStatusMaster || []).map((item) => [
            item.maritalStatusId,
            item.maritalStatus,
        ])
    );

    const religionMap = Object.fromEntries(
        (masterData?.religionMaster || []).map((item) => [
            item.religionId,
            item.religion,
        ])
    );

    const countryMap = Object.fromEntries(
        (masterData?.countries || []).map((item) => [
            item.countryId,
            item.countryName,
        ])
    );

    const stateMap = Object.fromEntries(
        (masterData?.states || []).map((item) => [
            item.stateId,
            item.stateName,
        ])
    );

    const districtMap = Object.fromEntries(
        (masterData?.districts || []).map((item) => [
            item.districtId,
            item.districtName,
        ])
    );

    const disabilityMap = Object.fromEntries(
        (masterData?.disabilityCategories || []).map((item) => [
            item.disabilityCategoryId,
            item.disabilityName,
        ])
    );

    const casteCategoryMap = Object.fromEntries(
        (masterData?.reservationCategories || []).map((item) => [
            item.reservationCategoriesId,
            item.categoryName,
        ])
    );

    const panDocument = documents.find(
        (doc) => doc.displayName === "Pan Card"
    );

    const passportDocument = documents.find(
        (doc) => doc.displayName === "Passport"
    );

    const drivingLicenceDocument = documents.find(
        (doc) => doc.displayName === "Driving Licence"
    );

    const disabilityCertificateDocument = documents.find(
        (doc) =>
            doc.displayName === "DISABILITY"
    );

    const addressProofDocument =
        response?.documents?.find(
            (doc) =>
                doc.documentType === "ADDRESS_PROOF"
        );

    return {
        // Personal Details
        gender: genderMap[profile.genderId] || "",
        dob: profile.dateOfBirth || "",
        maritalStatus:
            maritalStatusMap[profile.maritalStatusId] || "",

        mobile: profile.contactNo || "",
        email: profile.email || "",

        casteCommunity: profile.community || "",

        nationality:
            countryMap[profile.nationality] || "",

        religion:
            religionMap[profile.religionId] || "",

        casteCategory:
            casteCategoryMap[
            profile.reservationCategoryId
            ] || "",

        cibilScore: personalDetails.cibilScore?.toString() || profile.cibilScore?.toString() || "",

        cibilScoreDate: personalDetails.cibilScoreDate?.toString() || "",

        fatherName:
            profile.fatherName || "",

        motherName:
            profile.motherName || "",

        spouseName:
            profile.spouseName || "",

        minority:
            profile.minority ? "Yes" : "No",

        // Documents
        panNo:
            domicileDetails?.panNo || panDocument?.documentNumber || "",

        panFileUrl:
            panDocument?.fileUrl || "",

        passportNo:
            domicileDetails?.passportNo || passportDocument?.documentNumber || "",

        passportFileUrl:
            passportDocument?.fileUrl || "",

        // drivingLicenseNo:
        //     drivingLicenceDocument?.documentNumber || "",

        drivingLicenceFileUrl:
            drivingLicenceDocument?.fileUrl || "",

        // Disability
        personWithDisability:
            profile.disability ? "Yes" : "No",

        disabilities:
            data?.basicDetails?.disabilityDetails?.map(
                (item) => ({
                    disabilityCategoryId:
                        item.disabilityCategoryId,
                    disabilityPercentage:
                        item.disabilityPercentage,
                    natureOfDisability:
                        disabilityMap[
                        item.disabilityCategoryId
                        ] || "",
                })
            ) || [],

        disabilityBoardName:
            personalDetails?.disabilityCertificateBoardName || "",

        disabilityReferenceNumber:
            personalDetails?.disabilityCertificateReferenceNo || "",

        disabilityCertificateDate:
            personalDetails?.disabilityCertificateIssueDate || "",

        disabilityFile:
            disabilityCertificateDocument?.fileUrl || "",
        disabilityName:
            disabilityCertificateDocument?.fileName || "",

        // Correspondence Address
        corrAddressLine1:
            addressDetails.correspondenceAddressLine1?.toString() || address.addressLine1?.toString() || "",

        corrAddressLine2:
            addressDetails.correspondenceAddressLine2?.toString() || address.addressLine2?.toString() || "",

        corrAddressLine3:
            addressDetails.correspondenceAddressLine3?.toString() || address.addressLine3?.toString() || "",
        corrCity:
            address?.city || "",

        corrState:
            stateMap[address?.stateId] || "",

        corrDistrict:
            districtMap[address?.districtId] || "",

        corrPincode:
            address?.pincode || "",

        // Permanent Address
        permanentAddressLine1:
            address?.permanentAddressLine1 || "",

        permanentAddressLine2:
            address?.permanentAddressLine2 || "",

        permanentAddressLine3:
            addressDetails?.permanentAddressLine3 || "",

        permanentCity:
            address?.permanentCity || "",

        permanentState:
            stateMap[address?.permanentStateId] || "",

        permanentDistrict:
            districtMap[address?.permanentDistrictId] || "",

        permanentPincode:
            address?.permanentPincode || "",

        addressProofFileUrl:
            addressProofDocument?.documentUrl || "",

        // Domicile
        stateOfOrigin:
            stateMap[address?.permanentStateId] || "",

        stateOfDomicile:
            stateMap[address?.permanentStateId] || "",

        domicileDistrict:
            districtMap[address?.permanentDistrictId] || "",

        domicileCity:
            address?.permanentCity || "",

        bloodGroup:
            domicileDetails?.bloodGroup || "",

        voterId:
            domicileDetails?.voterIdCardNo || "",

        drivingLicenseNo:
            domicileDetails?.drivingLicenseNo || drivingLicenceDocument?.documentNumber || "",



        // Experience
        experienceDetails:
            data?.experienceDetails?.map((item) => ({
                workExperienceId:
                    item?.workExperience?.workExperienceId || "",

                panCardNumber: "",
                empCode: "",

                organisationName:
                    item?.workExperience?.organizationName || "",

                organisationAddress: "",

                designation:
                    item?.workExperience?.role || "",

                descriptionOfWork:
                    item?.workExperience?.workDescription || "",

                isPresentlyWorking: item?.workExperience?.isPresentlyWorking || false,

                lastDrawnSalary:
                    item?.workExperience?.currentCtc || "",

                fromDate:
                    item?.workExperience?.fromDate || "",

                toDate:
                    item?.workExperience?.toDate || "",

                reasonForLeaving: "",

                employerEmail: "",
                employerContact: "",

                experienceCertificateUrl:
                    item?.documentStore?.fileUrl || "",

                experienceCertificateName:
                    item?.documentStore?.displayName || "",
            })) || [],

        attestationDetails:
            response?.residentialHistory?.map(
                (item) => ({
                    id: item.id || "",
                    preOnboardingId:
                        item.preOnboardingId || "",
                    attestationFromDate:
                        item.fromDate || "",
                    attestationToDate:
                        item.toDate || "",
                    addressLine1:
                        item.addressLine1 || "",
                    addressLine2:
                        item.addressLine2 || "",
                    addressLine3:
                        item.addressLine3 || "",
                    cityId:
                        item.cityId || null,
                    districtId:
                        item.districtId || null,
                    stateId:
                        item.stateId || null,
                    pinCode:
                        item.pincode || "",
                    preOnboardingDocumentId:
                        item.preOnboardingDocumentId ||
                        null,
                })
            ) || [],
    };
};

export const mapPreviousEmploymentDetails = (
    response,
    masterData
) => {
    const states = masterData?.states || [];
    const districts = masterData?.districts || [];
    const cities = masterData?.cities || [];

    const experienceDetails =
    response?.previousOrganisations?.length > 0
        ? response.previousOrganisations.map(
              (item, index) => ({
                  workExperienceId: item.id || "",
                  preOnboardingId:
                      item.preOnboardingId || "",

                  pranCardNumber:
                      item.pranCardNumber || "",

                  empCode:
                      item.employeeCode || "",

                  organisationName:
                      item.organisationName || "",

                  organisationAddress:
                      item.organisationAddress || "",

                  designation:
                      item.designation || "",

                  descriptionOfWork:
                      item.workDescription || "",

                  lastDrawnSalary:
                      item.lastDrawnSalary || "",

                  fromDate:
                      item.fromDate || "",

                  toDate:
                      item.toDate || "",

                  reasonForLeaving:
                      item.reasonForLeaving || "",

                  employerEmail:
                      item.employerEmail || "",

                  employerContact:
                      item.employerContactNo || "",

                  isCurrentlyWorking:
                      item.isCurrentlyWorking,

                  experienceCertificateUrl:
                      response?.candidateParentModel
                          ?.experienceDetails?.[index]
                          ?.documentStore?.fileUrl || "",

                  experienceCertificateName:
                      response?.candidateParentModel
                          ?.experienceDetails?.[index]
                          ?.documentStore?.displayName || "",
              })
          )
        : response?.candidateParentModel?.experienceDetails?.map(
              (item) => ({
                  workExperienceId:
                      item?.workExperience?.workExperienceId || "",

                  preOnboardingId: null,

                  pranCardNumber: "",
                  empCode: "",

                  organisationName:
                      item?.workExperience
                          ?.organizationName || "",

                  organisationAddress: "",

                  designation:
                      item?.workExperience?.role || "",

                  descriptionOfWork:
                      item?.workExperience
                          ?.workDescription || "",

                  lastDrawnSalary:
                      item?.workExperience?.currentCtc || "",

                  fromDate:
                      item?.workExperience?.fromDate || "",

                  toDate:
                      item?.workExperience?.toDate || "",

                  reasonForLeaving: "",

                  employerEmail: "",

                  employerContact: "",

                  isCurrentlyWorking:
                      item?.workExperience
                          ?.isPresentlyWorking || false,

                  experienceCertificateUrl:
                      item?.documentStore?.fileUrl || "",

                  experienceCertificateName:
                      item?.documentStore?.displayName || "",
              })
          ) || [];



          const attestationDetails =
    response?.residentialHistory?.length > 0
        ? response.residentialHistory.map((item) => {
              const document =
                  response?.documents?.find(
                      (doc) =>
                          doc.id ===
                          item.preOnboardingDocumentId
                  );

              return {
                  id: item.id || "",
                  preOnboardingId:
                      item.preOnboardingId || "",

                  attestationFromDate:
                      item.fromDate || "",
                  attestationToDate:
                      item.toDate || "",

                  addressLine1:
                      item.addressLine1 || "",
                  addressLine2:
                      item.addressLine2 || "",
                  addressLine3:
                      item.addressLine3 || "",

                  cityId:
                      item.cityId || null,
                  districtId:
                      item.districtId || null,
                  stateId:
                      item.stateId || null,

                  pinCode:
                      item.pincode || "",

                  preOnboardingDocumentId:
                      item.preOnboardingDocumentId ||
                      null,

                  documentName:
                      document?.documentName || "",

                  documentUrl:
                      document?.documentUrl || "",

                  state:
                      states.find(
                          (s) =>
                              s.stateId === item.stateId
                      )?.stateName || "",

                  district:
                      districts.find(
                          (d) =>
                              d.districtId ===
                              item.districtId
                      )?.districtName || "",

                  city:
                      cities.find(
                          (c) =>
                              c.cityId === item.cityId
                      )?.cityName || "",
              };
          })
        : [
              {
                  id: "",
                  preOnboardingId: "",

                  attestationFromDate: "",
                  attestationToDate: "",

                  addressLine1:
                      response?.candidateParentModel
                          ?.addressDetails
                          ?.addressLine1 || "",

                  addressLine2:
                      response?.candidateParentModel
                          ?.addressDetails
                          ?.addressLine2 || "",

                  addressLine3: "",

                  stateId:
                      response?.candidateParentModel
                          ?.addressDetails?.stateId ||
                      null,

                  districtId:
                      response?.candidateParentModel
                          ?.addressDetails
                          ?.districtId || null,

                  cityId: null,

                  pinCode:
                      response?.candidateParentModel
                          ?.addressDetails?.pincode ||
                      "",

                  preOnboardingDocumentId:
                      null,

                  documentName: "",
                  documentUrl: "",

                  state: "",
                  district: "",
                  city: "",
              },
          ];

    return {
        experienceDetails:
            // response?.previousOrganisations?.map(
            //     (item, index) => ({
            //         workExperienceId: item.id || "",
            //         preOnboardingId:
            //             item.preOnboardingId || "",
            //         pranCardNumber:
            //             item.pranCardNumber || "",
            //         empCode:
            //             item.employeeCode || "",
            //         organisationName:
            //             item.organisationName || "",
            //         organisationAddress:
            //             item.organisationAddress || "",
            //         designation:
            //             item.designation || "",
            //         descriptionOfWork:
            //             item.workDescription || "",
            //         lastDrawnSalary:
            //             item.lastDrawnSalary || "",
            //         fromDate:
            //             item.fromDate || "",
            //         toDate:
            //             item.toDate || "",
            //         reasonForLeaving:
            //             item.reasonForLeaving || "",
            //         employerEmail:
            //             item.employerEmail || "",
            //         employerContact:
            //             item.employerContactNo || "",
            //             isCurrentlyWorking: item.isCurrentlyWorking,

            //         //My change
            //         experienceCertificateUrl:
            //             response?.candidateParentModel
            //                 ?.experienceDetails?.[index]
            //                 ?.documentStore?.fileUrl || "",

            //         experienceCertificateName:
            //             response?.candidateParentModel
            //                 ?.experienceDetails?.[index]
            //                 ?.documentStore?.displayName || "",
            //     })
            // ) || [],

             experienceDetails,

              attestationDetails,


        // attestationDetails:
        //     response?.residentialHistory?.map(
        //         (item) => {

        //             const document =
        //                 response?.documents?.find(
        //                     (doc) =>
        //                         doc.id ===
        //                         item.preOnboardingDocumentId
        //                 );

        //             return {
        //                 id: item.id || "",
        //                 preOnboardingId:
        //                     item.preOnboardingId || "",

        //                 attestationFromDate:
        //                     item.fromDate || "",
        //                 attestationToDate:
        //                     item.toDate || "",

        //                 addressLine1:
        //                     item.addressLine1 || "",
        //                 addressLine2:
        //                     item.addressLine2 || "",
        //                 addressLine3:
        //                     item.addressLine3 || "",

        //                 cityId:
        //                     item.cityId || null,
        //                 districtId:
        //                     item.districtId || null,
        //                 stateId:
        //                     item.stateId || null,

        //                 pinCode:
        //                     item.pincode || "",

        //                 preOnboardingDocumentId:
        //                     item.preOnboardingDocumentId ||
        //                     null,

        //                 documentName:
        //                     document?.documentName || "",

        //                 documentUrl:
        //                     document?.documentUrl || "",

        //                 state:
        //                     states.find(
        //                         (s) =>
        //                             s.stateId === item.stateId
        //                     )?.stateName || "",

        //                 district:
        //                     districts.find(
        //                         (d) =>
        //                             d.districtId ===
        //                             item.districtId
        //                     )?.districtName || "",

        //                 city:
        //                     cities.find(
        //                         (c) =>
        //                             c.cityId === item.cityId
        //                     )?.cityName || "",
        //             };
        //         }
        //     ) || [],

        // attestationDetails:
        //     response?.residentialHistory?.map(
        //         (item) => ({
        //             id: item.id || "",
        //             preOnboardingId:
        //                 item.preOnboardingId || "",
        //             attestationFromDate:
        //                 item.fromDate || "",
        //             attestationToDate:
        //                 item.toDate || "",
        //             addressLine1:
        //                 item.addressLine1 || "",
        //             addressLine2:
        //                 item.addressLine2 || "",
        //             addressLine3:
        //                 item.addressLine3 || "",
        //             cityId:
        //                 item.cityId || null,
        //             districtId:
        //                 item.districtId || null,
        //             stateId:
        //                 item.stateId || null,
        //             pinCode:
        //                 item.pincode || "",
        //             preOnboardingDocumentId:
        //                 item.preOnboardingDocumentId ||
        //                 null,

        //                  state:
        //                 states.find(
        //                     (s) =>
        //                         s.stateId === item.stateId
        //                 )?.stateName || "",

        //             district:
        //                 districts.find(
        //                     (d) =>
        //                         d.districtId === item.districtId
        //                 )?.districtName || "",

        //             city:
        //                 cities.find(
        //                     (c) =>
        //                         c.cityId === item.cityId
        //                 )?.cityName || "",
        //         })
        //     ) || [],
    };




};

export const mapQualificationDetails = (
    response,
    masterData
) => {
    const data =
        response?.candidateParentModel ||
        response?.data?.candidateParentModel ||
        {};

    const mandatoryQualifications =
        masterData?.mandatoryQualification || [];

    const specializations =
        masterData?.specializationMaster || [];

    const educationTypes =
        masterData?.educationTypeMaster || [];






    const data1 =
        response?.preOnboardingFamilyDetails ||
        response?.data?.preOnboardingFamilyDetails ||
        {};
    const data2 =
        response?.preOnboardingGratuityNomination ||
        response?.data?.preOnboardingGratuityNomination ||
        {};

    const data3 = response?.preOnboardingQualifications || {};

    const data4 =
        response?.preOnboardingCertifications || [];

    return {
        qualificationDetails:
            data?.educationDetails?.map((item) => {

                const qualification =
                    mandatoryQualifications.find(
                        (q) =>
                            q.educationQualificationsId ===
                            item?.education?.educationQualificationsId
                    );

                const specialization =
                    specializations.find(
                        (s) =>
                            s.specializationId ===
                            item?.education?.specializationId
                    );

                const educationType =
                    educationTypes.find(
                        (e) =>
                            e.educationTypeId ===
                            item?.education?.educationTypeId
                    );


                const preOnboardingQualification =
                    data3.find(
                        (q) =>
                            q.educationId ===
                            item?.education?.educationId
                    );

                return {
                    educationId:
                        item?.education?.educationId || "",

                    // Course
                    courseId:
                        item?.education?.educationQualificationsId || "",

                    courseName:
                        qualification?.qualificationName || "",

                    // Specialization
                    specializationId:
                        item?.education?.specializationId || "",

                    specializationName:
                        specialization?.specializationName || "",

                    // Institution
                    schoolInstitution:
                        item?.education?.institutionName || "",


                    // University
                    universityName:
                        item?.education?.universityName || "",

                    // Percentage
                    percentageMarks:
                        item?.education?.percentage || "",

                    // Passing Date
                    dateOfPassing:
                        item?.education?.endDate || "",

                    // Division
                    division:
                        preOnboardingQualification?.division || "",


                    // Nature Of Course
                    educationTypeId:
                        item?.education?.educationTypeId || "",

                    natureOfCourse:
                        educationType?.educationType || "",

                    uploadDocument: {
                        id:
                            item?.documentStore?.id || "",

                        name:
                            item?.documentStore?.displayName || "",

                        fileUrl:
                            item?.documentStore?.fileUrl || "",
                    },
                };
            }) || [],

        candidateCertifications:
            data?.candidateCertifications?.map(
                (item) => {

                    const preOnboardingCertification =
                        data4.find(
                            (q) =>
                                q.candidateCertificateId ===
                                item?.certifications?.certificateId
                        );

                    return {
                        certificationId:
                            item?.certifications?.certificateId || "",

                        certificationName:
                            item?.certifications?.certificationName || "",

                        institutionName:
                            item?.certifications?.issuedBy || "",

                        certificationDateOfPassing:
                            item?.certifications?.certificationDate || "",

                        certificationPercentage:
                            preOnboardingCertification?.percentage ||
                            item?.certifications?.percentage ||
                            "",

                        preOnboardingId:
                            preOnboardingCertification?.preOnboardingId || null,

                        id:
                            preOnboardingCertification?.id || null,

                        fileId:
                            item?.documentStore?.id || "",

                        displayName:
                            item?.documentStore?.fileName || "",

                        fileUrl:
                            item?.documentStore?.fileUrl || "",
                    };
                }
            ) || [],
        // candidateCertifications:
        //     data?.candidateCertifications?.map(
        //         (item) => ({

        //             certificationId:
        //                 item?.certifications?.certificateId || "",

        //             certificationName:
        //                 item?.certifications?.certificationName || "",

        //             institutionName:
        //                 item?.certifications?.issuedBy || "",

        //             certificationDateOfPassing:
        //                 item?.certifications?.certificationDate || "",

        //             certificationPercentage:
        //                 item?.certifications?.percentage || "",

        //             fileId:
        //                 item?.documentStore?.id || "",

        //             displayName:
        //                 item?.documentStore?.fileName || "",

        //             fileUrl:
        //                 item?.documentStore?.fileUrl || "",
        //         })
        //     ) || [],

        preOnboardingFamilyDetails: {
            familyId:
                data1.id || "",

            familyPreOnboardingId:
                data1.preOnboardingId || "",

            fullName:
                data1?.fullName || "",

            relationship:
                data1?.relationship || "",

            dateOfBirth:
                data1
                    ?.dateOfBirth || "",

            nationality:
                data1
                    ?.nationality || "",

            dependent:
                data1
                    ?.isDependent
                    ? "Yes"
                    : "No",

            benchmarkDisability:
                data1
                    ?.isPwd
                    ? "Yes"
                    : "No",

            occupation:
                data1
                    ?.occupation || "",

            annualIncome:
                data1
                    ?.annualIncome || "",

            mobileNumber:
                data1
                    ?.mobileNumber || "",
        },

        preOnboardingGratuityNomination: {
            gratuityId:
                data2
                    ?.id || "",

            gratuityPreOnboardingId:
                data2
                    ?.preOnboardingId || "",

            nomineeName:
                data2
                    ?.nomineeName || "",

            nomineeAddress:
                data2
                    ?.nomineeAddress || "",

            nomineeRelationship:
                data2
                    ?.nomineeRelationship || "",

            nomineeAge:
                data2
                    ?.nomineeAge || "",

            amountOfShare:
                data2
                    ?.sharePercentage || "",
        },

    };
};


export const mapOtherDetails = (
    response,
    masterData
) => {
    const data = response;

    return {
        preOnboardingReferences:
            data?.preOnboardingReferences?.map(
                (item) => ({
                    id: item?.id || "",

                    preOnboardingId:
                        item?.preOnboardingId || "",

                    referenceName:
                        item?.referenceName || "",

                    referenceDesignation:
                        item?.designation || "",

                    referenceOrganisation:
                        item?.organisation || "",

                    referenceContact:
                        item?.contactNumber || "",

                    referenceEmail:
                        item?.emailId || "",
                })
            ) || [
                {
                    id: "",
                    preOnboardingId: "",
                    referenceName: "",
                    referenceDesignation: "",
                    referenceOrganisation: "",
                    referenceContact: "",
                    referenceEmail: "",
                },
                {
                    id: "",
                    preOnboardingId: "",
                    referenceName: "",
                    referenceDesignation: "",
                    referenceOrganisation: "",
                    referenceContact: "",
                    referenceEmail: "",
                },
            ],

        preOnboardingOtherDetails: {
            id:
                data?.preOnboardingOtherDetails?.id || "",

            preOnboardingId:
                data?.preOnboardingOtherDetails?.preOnboardingId || "",

            markOfIdentification:
                data?.preOnboardingOtherDetails?.identificationMark || "",

            practicalTraining:
                data?.preOnboardingOtherDetails?.practicalTrainingDetails || "",

            publications:
                data?.preOnboardingOtherDetails?.publicationDetails || "",

            futureCourse:
                data?.preOnboardingOtherDetails?.furtherCourseDetails || "",

            professionalMembership:
                data?.preOnboardingOtherDetails?.professionalBodyDetails || "",

            legalHistory:
                data?.preOnboardingOtherDetails?.criminalCaseDetails || "",

            otherInformation:
                data?.preOnboardingOtherDetails?.additionalInformation || "",
        }
    };
};

// export const mapQualificationDetails = (
//     response,
//     masterData
// ) => {
//     const data =
//         response?.candidateParentModel ||
//         response?.data?.candidateParentModel ||
//         {};

//     return {
//         qualificationDetails:
//             data?.educationDetails?.map(
//                 (item) => ({
//                     educationId:
//                         item?.education?.educationId || "",

//                     courseId:
//                         item?.education?.educationQualificationsId || "",
//                     courseName:
//                         item?.education?.educationQualificationsName || "",

//                     specialization: item?.education?.specializationName || "",
//                     specializationId: item?.education?.specializationId || "",

//                     schoolInstitution:
//                         item?.education
//                             ?.institutionName || "",

//                     mainSubject:
//                         item?.education
//                             ?.otherSpecialization || "",

//                     universityName:
//                         item?.education
//                             ?.universityName || "",

//                     percentageMarks:
//                         item?.education
//                             ?.percentage || "",

//                     dateOfPassing:
//                         item?.education
//                             ?.endDate || "",

//                     division:
//                         item?.education
//                             ?.division || "",

//                     natureOfCourse:
//                         item?.education
//                             ?.educationTypeName || "",

//                     uploadDocument: {
//                         id:
//                             item?.documentStore?.id ||
//                             "",

//                         name:
//                             item?.documentStore
//                                 ?.displayName || "",

//                         fileUrl:
//                             item?.documentStore
//                                 ?.fileUrl || "",
//                     },
//                 })
//             ) || [],
//     };
// };